export enum ProductType {
    NORMAL = 1
    , BOM = 2
}


// WEBPACK FOOTER //
// ./src/enums/producttype.enum.ts